<!-- Download (下载-介绍页)：2020/3/10 Vue: ^2.5.2 YuAng-->

<template>
  <div class="its-Download">
    <!-- banner -->
    <banner :banners="banners" :height="'775px'" :tabs="tabs"></banner>
    <!-- <download-tabs :tabs="tabs"></download-tabs> -->
  </div>
</template>

<script>
import Banner from './components/Banner'
import { downloadCenterApi } from '@/utils/api'
export default {
  name: 'Download',
  components: {
    Banner
  },
  props: {
    type: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      banners: [
        {
          background: 'images/download_banner_bg.png',
          src: 'images/download_banner1.png',
          desc: 'images/download_banner_desc1.png'
        }
      ],
      tabs: [
        {
          id: 1,
          mainTitle: 'e课堂教师电脑端',
          item: {
            key: 1,
            position: 'right',
            code: false,
            identity: 'EASY_CLASS_PC',
            desc: '学科特色优质内容，在线协同轻松备课，学科工具、趣味互动随心应用，随堂测验即时反馈，提效课堂。',
            downloadUrl: '',
            download: true,
            images: ['1.png', '2.png', '3.png'],
            btn: '<i class="its-icon its-icon-diannao"></i>下载电脑端'
          }
        },
        // {
        //   id: 2,
        //   mainTitle: 'e课堂教师APP',
        //   item: {
        //     key: 2,
        //     position: 'left',
        //     code: true,
        //     identity: 'TEACHER_ANDROID',
        //     desc: '移动授课双屏互动，实现走动教学；预习训练灵活布置；学情反馈实时呈现，靶向指导精准教学。',
        //     downloadUrl: '',
        //     download: true,
        //     images: ['5.png', '6.png'],
        //     btn: '<i class="its-icon its-icon-anzhuo"></i>下载安卓版本',
        //     qrcodeUrl: location.origin + '/official/eclass/mobile/download/teacher'
        //   }
        // },
        // {
        //   id: 3,
        //   mainTitle: 'e课堂学生APP',
        //   item: {
        //     key: 3,
        //     position: 'right',
        //     code: true,
        //     identity: 'STUDENT_ANDROID',
        //     desc: '预习训练一键查收；师生多样趣味互动；学情实时查看；专项突破、同步巩固，个性化提升。',
        //     downloadUrl: '',
        //     download: true,
        //     images: [{width: 473, height: 304, src: 'school/area-part3-121.png'}],
        //     btn: '<i class="its-icon its-icon-anzhuo"></i>下载安卓版本',
        //     qrcodeUrl: location.origin + '/official/eclass/mobile/download/student'
        //   }
        // },
        {
          id: 2,
          mainTitle: 'e课堂家长通',
          item: {
            key: 2,
            position: 'left',
            code: false,
            identity: 'WECHAT',
            desc: '定期接收学情报告，客观了解孩子学习轨迹，家校互动互联，<br>共育孩子成长。',
            downloadUrl: '',
            btn: '<i class="its-icon its-icon-shouji"></i>扫码了解更多',
            images: ['8.png', '9.png'],
            download: false
          }
        }
      ],
      appDownloads: []
    }
  },
  mounted() {
    this.getAppDownloads()
    window.addEventListener('scroll', this.handleScroll)
    setTimeout(() => {
      document.body.scrollTop = document.documentElement.scrollTop = 0 
    }, 500)
  },
  methods: {
    handleScroll: function () {
      this.$root.setHeaderBackground()
    },
    getAppDownloads: function () {
      downloadCenterApi.getAllOnlineAppDownload().then((res) => {
        console.log(res)
        if (res.success) {
          this.appDownloads = res.body
          this.tabs.forEach((tab) => {
            let download = this.getDownloadByIdentity(tab.item.identity)
            tab.item.downloadUrl = download.url
          })
          console.log('tabs new', this.tabs)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getDownloadByIdentity: function (identity) {
      let app = {}
      this.appDownloads.forEach((item) => {
        if (item.identity === identity) {
          app = item
          return
        }
      })
      return app
    }
  }
}
</script>

<style scoped>
.its-Download {
  color: blue;
  min-height: 50px;
  position: relative;
}
.its-banner {
  position: absolute;
  top: 205px;
  right: 81px;
}
</style>
